/*
 *   File : text-button.js
 *   Author : https://evoqins.com
 *   Description : Text button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useState } from "react";

//assets
import RightArrow from "../../Assets/Images/right-black-small.svg";
import RightBlue from "../../Assets/Images/right-blue-icon.svg";
import { Icon } from "../Icon";

const TextButton = (props) => {

    const [hover, setHover] = useState(false);

    return (
        <>
            {
                props.type === 3 ?
                    <div className={`d-inline-flex align-items-center gap-1 cursor-pointer hover-arrow-wrapper ${props.wrapperClassName}`}
                        onMouseOver={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onClick={props.onClick} >
                        <button className={`e-font-14-res no-border e-bg-transparent e-text-egyptian-blue e-font-14 e-primary-font-inter e-font-weight-500 line-height-30px`}>
                            <span className={hover ? `e-border-bottom-1px-egyptian-blue e-text-egyptian-blue` : `e-border-bottom-transparent`}
                                onClick={props.onClick}  >
                                {props.name}
                            </span>
                        </button>
                        <Icon icon="arrow-down"
                            color="#1C359F"
                            className={props.iconClassName}
                            size={14} />
                    </div>
                    :

                    props.type === 2 ?
                        <div className={`${props.className} d-inline-flex width-max-content border-bottom-dotted align-items-center gap-1 cursor-pointer`} onClick={props.onClick}>
                            {
                                props.icon !== false &&
                                <Icon icon="edit-icon"
                                    className="cursor-pointer"
                                    size={12} />
                            }
                            <span className={`${props.textClassName} ${props.fontSize || "e-font-16  e-font-14-res"} e-text-egyptian-blue e-alt-font-poppins e-font-weight-500`}>{props.name}</span>
                        </div>
                        :
                        <div className={`e-inline-flex gap-0-6px cursor-pointer hover-arrow-wrapper ${props.wrapperClassName}`}
                            onMouseOver={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                            onClick={props.onClick} >
                            <button className={`e-font-14-res no-border e-bg-transparent e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-500 line-height-14px`}>
                                <span className={hover ? `e-border-bottom-1px-egyptian-blue e-text-egyptian-blue` : `e-border-bottom-transparent`}
                                    onClick={props.onClick}  >
                                    {props.name}
                                </span>
                            </button>
                            <img src={hover ? RightBlue : RightArrow}
                                className="hover-arrow"
                                draggable="false"
                                alt="arrow" />
                        </div>
            }
        </>
    )
}
export default TextButton;

TextButton.defaultProps = {
    onClick: () => { },
}